import React, { useEffect, useRef, useState } from "react";
import "./Share_Experience.css";
import { Form } from "react-bootstrap";
import Pink_Btn from "../../../common/common_btn/pink_btn/Pink_Btn";
import Success_Modal from "../../../common/common_modal/success_modal/Success_Modal";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { Share_Your_Experience } from "../../../../features/admin/common/Slice";

const Share_Experience = () => {

  const dispatch = useDispatch();
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const fileInputRef = useRef(null);
  const [mediaFile, setMediaFile] = useState(null);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("message", data.message);

      if (mediaFile) {
        formData.append("image", mediaFile);
      }

      const response = await dispatch(Share_Your_Experience(formData))
      if (response?.meta?.requestStatus === "fulfilled") {
        setShowSucsessModal(true);
        reset();
        setMediaFile(null)
        setTimeout(() => {
          // setShowSucsessModal(false);
        }, 3000);
      }


    } catch (error) {
      console.error("Experience error:", error);
    }
  };
  useEffect(() => {
    return () => {
      if (mediaFile) {
        URL.revokeObjectURL(mediaFile);
      }
    };
  }, [mediaFile]);


  return (
    <div className="Share_Experience">

      <Form >
        <Form.Group className="gray_input_group">
          <Form.Label>Share Your Experience</Form.Label>

          <div className="input_holder expeience_form_group">
            <Form.Control
              as="textarea"
              placeholder="Type Here..."

              {...register("message", {
                required: "Please write your experience",
                minLength: {
                  value: 10,
                  message: "Experience must be at least 10 characters",
                },
              })}
            />

            <img
              src="/assets/images/profile/spiritual_dashboard/pin.png"
              className="pin_img"
              alt="pin"
              onClick={() => fileInputRef.current.click()}
              style={{ cursor: "pointer"
              }}
            />
            <input
              type="file"
              ref={fileInputRef}
              accept="image/*,video/*"
              style={{ display: "none" }}
              onChange={(e) => setMediaFile(e.target.files[0])}
            />

          </div>

          {errors.message && (
            <p style={{ color: "red", fontSize: "13px" }}>
              {errors.message.message}
            </p>
          )}
        </Form.Group>
        {mediaFile && (
          <div style={{ marginTop: "10px" }}>
            {mediaFile.type.startsWith("video") ? (
              <video
                src={URL.createObjectURL(mediaFile)}
                controls
                   style={{ cursor: "pointer" , width:"100px", height: "100px", objectFit:"contain",
                aspectRatio:"1/1",borderRadius:"5px"
              }}
              />
            ) : (
              <img
                src={URL.createObjectURL(mediaFile)}
                alt="preview"
                   style={{ cursor: "pointer" , width:"100px", height: "100px", objectFit:"contain",
                aspectRatio:"1/1", borderRadius:"5px"
              }}
              />
            )}
          </div>
        )}


        <div className="btn_holder mt-4">
          <Pink_Btn btnText={"Post"} onClick={handleSubmit(onSubmit)} />
        </div>

      </Form>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSucsessModal(false)}
        successText="Response Submitted Successfully!"
      />
    </div>
  );
};

export default Share_Experience;
